import { ConstData } from "./helpers";

export const CONTACT_TYPES: ConstData[] = [
  { title: "Student", value: 0 },
  { title: "Parent", value: 1 },
  { title: "Staff", value: 2 },
]

export const CONTACT_INSTALMENTS: ConstData[] = [
  { title: "Quarterly", value: 0 },
  { title: "Monthly", value: 1 },
]


export const CONTACT_GRADES: ConstData[] = [
  { title: "Year 6", value: 6 },
  { title: "Year 7", value: 7 },
  { title: "Year 8", value: 8 },
  { title: "Year 9", value: 9 },
  { title: "Year 10", value: 10 },
  { title: "Year 11", value: 11 },
  { title: "Year 12", value: 12 },
  { title: "Alumnus", value: 13 },
]

export const CONTACT_GENDERS: ConstData[] = [
  { title: "Male", value: 0 },
  { title: "Female", value: 1 },
  { title: "Other", value: 2 },
]

export const CONTACT_SALUTATIONS: ConstData[] = [
  { title: "Mr", value: "Mr" },
  { title: "Mrs", value: "Mrs" },
  { title: "Miss", value: "Miss" },
]

export const CONTACT_MARKETING_SOURCES: ConstData[] = [
  { title: "Shopping Centre", value: "Shopping Centre" },
  { title: "Train Billboard", value: "Train Billboard" },
  { title: "Friend/Family", value: "Friend/Family" },
  { title: "Newspaper", value: "Newspaper" },
  { title: "School", value: "School" },
  { title: "Facebook", value: "Facebook" },
  { title: "Google Advertisement", value: "Google Advertisement" },
  { title: "Internet Search Engine", value: "Internet Search Engine" },
  { title: "Other", value: "Other" },
]

export const CONTACT_STATES: ConstData[] = [
  { title: "New South Wales", value: "NSW" },
  { title: "Victoria", value: "VIC" },
  { title: "ACT", value: "ACT" },
  { title: "South Australia", value: "SA" },
  { title: "Queensland", value: "QLD" },
  { title: "Western Australia", value: "WA" },
  { title: "Northern Territory", value: "NT" },
]

export const CONTACT_PHONE_LABELS: ConstData[] = [
  { title: "Mobile", value: "mobile" },
  { title: "Home", value: "home" },
  { title: "Work", value: "work" },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/contacts.ts